export const flemishWall = `\
-- flemish bond
-- alternating stretcher/header within each course, offset per row
-- real brick 210x100x50 mm

@unit 4px

S = 21
H = 10

S H >>
S H
`
